<template>
  <div class="device-header-container">
    <div class="btns-content">
      <div
        class="btn-item"
        v-for="(item, index) in menus"
        :style="{ 'z-index': menus.length - index }"
        @click="selectTab(index)"
        :class="{ active: index == current }"
      >
        <i class="zt" :class="item.icon"></i><span>{{ item.label }}</span>
      </div>
    </div>
    <div class="select-param">
      <el-select
        v-model="modelValue"
        value-key="moduleName"
        placeholder="请选择"
        class="select-tab"
        size="mini"
        @change="selectChange"
      >
        <el-option
          v-for="item in moduleTypeCategory"
          :key="item.moduleType"
          :label="item.moduleName"
          :value="item"
        >
        </el-option>
      </el-select>
    </div>
  </div>
</template>
<script>
import Core from '@/libs/src/core'
export default {
  data() {
    return {
      current: 0,
      modelValue: {},
      modelOptions: [
        {
          label: "工艺参数",
          value: "1",
        },
        {
          label: "高级设置",
          value: "2",
        },
      ],
      menus: [
        {
          label: "调试",
          icon: "",
          active: true,
        },
        {
          label: "自动运行",
          icon: "",
          active: false,
        },
        {
          label: "自定义运行",
          icon: "",
          active: false,
        },
        {
          label: "检修",
          icon: "",
          active: false,
        },
      ],
      moduleTypeCategory:[]
    };
  },
  created() {
    this.DPC = Core.getProvider(Core.providerTypes.DPC);
    this.init()
  },
  methods: {
    init() {
      const modules = this.DPC.modules;
      this.moduleTypeCategory = this.DPC.originalModulesData;
      console.log(this.moduleTypeCategory)
      this.modelValue = this.moduleTypeCategory[0]
      this.$emit('changeType',this.modelValue)
    },
    selectTab(index) {
      this.current = index;
      this.$emit("change", {
        index: index,
        menu: this.menus[index],
      });
    },
    selectChange(){
      this.$emit('changeType',this.modelValue)
    }
  },
};
</script>
<style lang="scss">
.device-header-container {
  display: flex;
  justify-content: space-between;
  .btns-content {
    display: flex;
    .btn-item {
      min-width: 100px;
      text-align: center;
      padding: 10px;
      cursor: pointer;
      background: url(@/assets/devicePlan/noactive.png) no-repeat center;
      background-size: 100% 100%;

      &:not(:nth-child(1)) {
        margin-left: -20px;
      }
      &.active {
        background: url(@/assets/devicePlan/active.png) no-repeat center;
        background-size: 100% 100%;
      }
    }
  }
  .select-tab {
    border-radius: 100px;
    background: rgba(175, 210, 237, 1);
    width: 120px;
    overflow: hidden;
    text-align: center;
    input.el-input__inner {
      background: rgba(175, 210, 237, 1);
      color: #000;
      text-align: center;
    }
    .el-input__suffix {
      margin-right: 12px;
    }
    .el-input__icon {
      color: #000 !important;
    }
  }
}
</style>